import { render, staticRenderFns } from "./TabColTei.vue?vue&type=template&id=296ba92a&"
import script from "./TabColTei.vue?vue&type=script&lang=js&"
export * from "./TabColTei.vue?vue&type=script&lang=js&"
import style0 from "./TabColTei.vue?vue&type=style&index=0&id=296ba92a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports